export default __webpack_public_path__ + "static/media/04.da20af73.png";